module.exports = __webpack_public_path__ + "static/img/img2.2ef498e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingPage/bussiness/img2.png
// module id = eQqH
// module chunks = 30